<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/KfXcVI/tc-custom/9781452112848.jpg?1728259590413" alt="This image is the cover for the book Crêpes"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Crêpes
      </h1>
      <p class="bookDescription body article font2">
        <b>Explore the versatility of this everyday, every-occasion food with the coauthor of the James Beard Award-winner <i>Six Seasons</i>.</b><br/><br/>Martha Holmberg is uniquely equipped to bring crêpes into the home kitchen. Trained at the renowned La Varenne cooking school, she has been a food writer, editor, and cook in the United States, England, and France for the past two decades. Her lifelong love of this favorite food is apparent throughout this collection of 50 sweet and savory recipes, ranging from the simple and snacky Butter-Sugar-Lemon of her teenage years to the crêpe cakes and cannelloni of an accomplished cook. Her encouraging instructions and master formulas produce beautiful crêpes and tempting sauces and fillings that pay homage to the classics while also playing with ambitious and fascinating flavor combinations and ingredients.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Martha Holmberg, James Baigrie
      </h2>
      
      <p class="authorDescription body article">Martha Holmberg is the former publisher and editor of Fine Cooking magazine, the founding editor of MIX magazine, and the former food editor of the Oregonian newspaper. She is also the author of Puff, a Julia Child Award–finalist cookbook. She lives in Portland, Oregon.James Baigrie is a San Francisco–based photographer specializing in food, interiors, and travel.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Chronicle
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?ecf8953e